import React, { useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./ConstitutionsBylawsStyles.css";
import Shikhaa_Logo from "../../Assets/Cover/Shikhaa_Logo.png";
// install react-pdf-viewer using this:  npm install @react-pdf-viewer/core @react-pdf-viewer/default-layout
// PDF assets
import pdf1 from "../../Assets/Constitutions/By_Laws_Shikhaa_Inc.pdf";

function ConstitutionsBylaws() {
  const [selectedPdf, setSelectedPdf] = useState(null);

  // Function to handle button clicks
  const handlePdfClick = (pdf) => {
    setSelectedPdf(pdf);
  };

  return (
    <div className="constBylaws-container">
      <div className="Shikhaa_Const_logo">
        <img id="Shikhaa-Const-logo" src={Shikhaa_Logo}></img>
      </div>
      <h1>CONSTITUTIONS AND BYLAWS</h1>
      <div>
        <button onClick={() => handlePdfClick(pdf1)}>
          Shikhaa Constitutions & Bylaws
        </button>
      </div>

      {selectedPdf && (
        <div>
          <div>
            <h2>PDF Preview:</h2>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl={selectedPdf} />
            </Worker>
          </div>
          <div>
            <a href={selectedPdf} download>
              <button>Download PDF</button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default ConstitutionsBylaws;
